import BeleidBloedingenBijDeHuisarts from "../../../../src/client/lta-antistolling/beleid-bloedingen-bij-de-huisarts.json";
import * as React from 'react';
export default {
  BeleidBloedingenBijDeHuisarts,
  React
};